// actionTypes.ts
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const TOGGLE_FLAG = 'TOGGLE_FLAG';
